module.exports = `fragment statement on Contentstack_statement {
    logo_statement {
      title
      url
    }
    enabled_statement
    text_statement
  }`;